<template>
  <div class="mt-2">
    <div class="col-12 p-0">
      <i class="material-icons float-right pr-2" data-toggle="modal" data-target="#materialModal" @click.prevent="setCurrentMaterial({ name: '', is_inside: true, is_outside: true, file: null }), edit_mode = false, error = ''">add</i>
      <h2 class="block-header mb-0" data-toggle="collapse" href="#materials" role="button" aria-expanded="true" aria-controls="materials">
        Материалы
      </h2>
    </div>
    <div class="col-12 align-self-center collapse show p-0" id="materials">
      <table class="table table-hover">
        <thead>
          <th>Название</th>
          <th>Внутри</th>
          <th>Снаружи</th>
          <th>Текстура</th>
        </thead>
        <tbody>
          <tr v-for="material in materials" :key="'material_' + material.id" class="cursor-pointer" data-toggle="modal" data-target="#materialModal" @click.prevent="setCurrentMaterial(material), edit_mode = true, error = ''">
            <td>{{ material.name }}</td>
            <td>{{ material.is_inside == true ? 'Да' : 'Нет' }}</td>
            <td>{{ material.is_outside == true ? 'Да' : 'Нет' }}</td>
            <td><img :src="material.file" class="texture-preview"/></td>
          </tr>
        </tbody>
      </table>

      <div class="modal fade" id="materialModal" tabindex="-1" role="dialog" aria-labelledby="materialModal" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ !edit_mode ? 'Добавить материал' : 'Редактировать материал' }}</h5>
              <button ref="closeMaterialModal" type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form enctype="multipart/form-data" action="#">
                <div class="form-group row ml-0 mr-2 mb-1 mt-1">
                  <label class="col-6 text-right" for="name">Название</label>
                  <input class="col-6 form-control" id="name" v-model="material_edit.name" required>
                </div>
                <div class="form-group row ml-0 mr-2 mb-1 mt-1">
                  <label class="col-6 text-right cursor-pointer" for="is_inside">Применим изнутри</label>
                  <label class="col-6 p-0" for="is_inside">
                    <i v-if="!material_edit.is_inside" class="material-icons checkbox float-right">check_box_outline_blank</i>
                    <i v-if="material_edit.is_inside" class="material-icons checkbox float-right">check_box</i>
                  </label>
                  <input type="checkbox" class="d-none" id="is_inside" v-model="material_edit.is_inside">
                </div>
                <div class="form-group row ml-0 mr-2 mb-1 mt-1">
                  <label class="col-6 text-right cursor-pointer" for="is_outside">Применим снаружи</label>
                  <label class="col-6 p-0" for="is_outside">
                    <i v-if="!material_edit.is_outside" class="material-icons checkbox float-right">check_box_outline_blank</i>
                    <i v-if="material_edit.is_outside" class="material-icons checkbox float-right">check_box</i>
                  </label>
                  <input type="checkbox" class="d-none" id="is_outside" v-model="material_edit.is_outside">
                </div>
                <div class="form-group row ml-0 mr-2 mb-1 mt-1">
                  <label class="col-6 text-right" for="file">Файл текстуры</label>
                  <input class="col-6" id="file" type="file" accept="image/*" @change="setTexture">
                </div>
                <div v-if="texturePreview.length > 0" class="form-group row ml-0 mr-2 mb-1 mt-1">
                  <img class="texture ml-auto" :src="texturePreview"/>
                </div>
              </form>
              <div v-if="error.length > 0" class="alert alert-danger" role="alert">{{ error }}</div>
            </div>
            <div class="modal-footer">
              <button v-if="edit_mode" type="button" class="btn btn-outline-danger mr-auto" @click="deleteMaterial">Удалить</button>
              <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">Отмена</button>
              <button type="button" class="btn btn-outline-primary" @click="saveMaterial">Сохранить</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: "Materials",
  props: {
    materials: Array,
  },
  data() {
    return {
      material_edit: {
        name: '',
        is_inside: true,
        is_outside: true,
        file: null,
      },
      edit_mode: false,
      error: '',
    }
  },
  computed: {
    texturePreview() {
      if (this.material_edit.file == null) {
        return '';
      }
      if (typeof this.material_edit.file == 'object') {
        return window.URL.createObjectURL(this.material_edit.file);
      } else {
        return this.material_edit.file;
      }
    },
  },
  methods: {
    setCurrentMaterial(material) {
      this.material_edit = JSON.parse(JSON.stringify(material));
    },
    setTexture(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (files.length > 0) {
        this.material_edit.file = files[0];
      }
    },
    saveMaterial() {
      this.error = '';
      var form_data = new FormData();
      form_data.append("name", this.material_edit.name);
      form_data.append("is_inside", this.material_edit.is_inside);
      form_data.append("is_outside", this.material_edit.is_outside);
      if (typeof this.material_edit.file == 'object') {
        form_data.append("file", this.material_edit.file);
      }
      if (!this.edit_mode) {
        axios.post('materials', form_data, {headers: {'Content-Type': 'multipart/form-data'}}).then((resp) => {
          this.materials.push(resp.data);
          this.$refs.closeMaterialModal.click();
        }).catch(() => {
          this.error = 'Название и файл должны быть заполнены';
        });
      } else {
        axios.patch(`materials/${this.material_edit.id}`, form_data, {headers: {'Content-Type': 'multipart/form-data'}}).then((resp) => {
          this.materials.forEach(material => {
            if (material.id == resp.data.id) {
              material.name = resp.data.name;
              material.is_inside = resp.data.is_inside;
              material.is_outside = resp.data.is_outside;
              material.file = resp.data.file;
            }
          });
          this.$refs.closeMaterialModal.click();
        });
      }
    },
    deleteMaterial() {
      axios.delete(`materials/${this.material_edit.id}`).then(() => {
        this.materials.splice(this.materials.indexOf(this.material_edit), 1);
        this.$refs.closeMaterialModal.click();
      });
    },
  },
}
</script>

<style>
.texture-preview {
  height: 20px;
}
.texture {
  height: 200px;
}
</style>
